<template>
<div>
        <main class="d-flex justify-content-center inicio-home"> 
            <div class="container">

                <ul class="step d-flex flex-nowrap" v-if="form!=2">
                    <li class="step-item">
                        <a class="">Datos personales</a>
                    </li>
                    <li class="step-item" :class="{ active: form ==0}">
                        <a class="">Datos laborales</a>
                    </li>
                    <li class="step-item" :class="{ active: form ==1}">
                        <a class="" @click="agregarBankCl">Datos bancarios</a>
                    </li>
                </ul>
                <div class="row">
                    <div class="col-md-3 text-center p-5">
                        <img src="@/assets/img/t-o.png" alt=""><br>
                        <h6 class="text-center mt-2">Tiempo estimado para<br>
                            tu operación</h6> 
                        <h4 v-text="tiempoEstimado"></h4> <br>
                        <h6>Sigue los pasos para
                        <br>completar tu operación</h6>
                        <div class="col-md-12 d-flex text-start p-2">
                            <p class="numero flex-shrink-0 me-2">1</p>
                                <p class="pb-3 mb-0 small lh-sm p-3" v-text="pasoOperacion1">
                                </p>     
                        </div>
                        <div class="col-md-12 d-flex text-start p-2">
                            <p class="numero flex-shrink-0 me-2">2</p>
                                <p class="pb-3 mb-0 small lh-sm p-3" v-text="pasoOperacion2">
                                </p>
                        </div>
                        <div class="col-md-12 d-flex text-start p-2">
                            <p class="numero flex-shrink-0 me-2">3</p>
                                <p class="pb-3 mb-0 small lh-sm p-3" v-text="pasoOperacion3">
                                </p>
                        </div>
                    </div>

                    <div class="col-md-6 calculadora p-5re" id="">
                        <div class="col-md col-sm  mb-2 texto-cambio">
                            <h3 class="text-center">Hola {{nombreCompleto.split(' ')[0]}}</h3><br>
                            <h4 class="text-center t-c">Tipo de cambio<span> actual</span></h4>
                        </div> 
                            <div v-if="tipoCambio==1" class="d-flex justify-content-between">
                                <p class="text-center sub-t">Compramos USD <br><font size="4" face="arial black" > S/{{CambioCompra}}</font></p>
                                <p class="text-center sub-t">Vendemos USD <br> S/{{CambioVenta}}</p>
                            </div>
                            <div v-if="tipoCambio==2" class="d-flex justify-content-between">
                                <p class="text-center sub-t">Compramos USD <br> S/{{CambioCompra}}</p>
                                <p class="text-center sub-t">Vendemos USD <br> <font size="4" face="arial black" >S/{{CambioVenta}}</font></p>
                            </div>
                        <div v-if="tipoCambio==1">
                            <div class="col-md col-sm d-flex mb-2 cambio">
                                <p class="flex-shrink-0 small me-2 mb-0">
                                    USD <small class="texto-grande">$</small></p>
                               
                                <div class="mb-0 small  me-auto" style="text-align: right;">
                                    Envías dólares <br>
                                    <input type="text" class="v-cambio"  id="ValorEnviar1" v-model="ValorEnviar1" @keyup="CambiarMonedaEnviar" @keypress="soloFloatEnviar" minlength="4" maxlength="9" size="6" :disabled="disabled"> 
                                </div>
                            </div>
                            <div class="col-sm-7 mb-2 ">
                                <img class="flechas-cambio1" v-on:click="tipocambiar" src="@/assets/img/flechas-cambio.svg" width="30" alt="">
                            </div>
                           
                            <div class="col-md col-sm  d-flex cambio">
                                <p class="flex-shrink-0 small me-2 mb-0">
                                    PEN <small class="texto-grande">S/</small></p>
                                <div class="mb-0 small  me-auto" style="text-align: right;">
                                    Recibes soles <br>
                                    <input type="text" class="v-cambio"  id="ValorRecibir1" v-model="ValorRecibir1"  @keyup="CambiarMonedaRecibir" @keypress="soloFloatRecibir" minlength="4" maxlength="9" size="6" :disabled="disabled">  
                    
                                </div>
                            </div>
                        </div>

                        <div v-if="tipoCambio==2">
                            <div class="col-md col-sm d-flex mb-2 cambio">
                                <p class="flex-shrink-0 small me-2 mb-0">
                                    PEN <small class="texto-grande">S/</small></p>
                               
                                <div class="mb-0 small  me-auto" style="text-align: right;">
                                    Envías soles <br>
                                    <input type="text" class="v-cambio"  id="ValorEnviar2" v-model="ValorEnviar2"  @keyup="CambiarMonedaEnviar" @keypress="soloFloatEnviar" minlength="4" maxlength="9" size="5" :disabled="disabled"> 
                                    
                                    <!--<small class="texto-grande">1200</small>-->
                                </div>
                            </div>
                            <div class="col-sm-7 mb-2 ">
                                <img class="flechas-cambio1" v-on:click="tipocambiar" src="@/assets/img/flechas-cambio.svg" width="30" alt="">
                            </div>
                           
                            <div class="col-md col-sm  d-flex cambio">
                                <p class="flex-shrink-0 small me-2 mb-0">
                                    USD <small class="texto-grande">$</small></p>
                                <div class="mb-0 small  me-auto" style="text-align: right;">
                                    Recibes dólares <br>
                                    <input type="text" class="v-cambio"  id="ValorRecibir2" v-model="ValorRecibir2"  @keyup="CambiarMonedaRecibir" @keypress="soloFloatRecibir" minlength="4" maxlength="9" size="5" :disabled="disabled">  
                    
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="col-md col-sm d-flex me-auto cupon">
                            <div class="mb-0  small">
                                    <input type="text" class="inp-cupon" autocomplete="off" id="ValorCupon" v-model="ValorCupon" placeholder="INGRESE SU CUPÓN"  size="23" maxlength="30" :disabled="disabled">  
                            </div>
                            <div class="flex-shrink-0 me-auto mb-0">
                                <button type="button"  class="btn btn-sm btn-registro" @click="validarCupon">APLICAR</button>
                                <button type="button"  class="btn btn-sm btn btn-cancelar" @click="limpiarCupon">QUITAR</button>
                            </div>
                        </div>  
                        <br>
                        <div v-if="Cupon==1">
                           <div v-if="tipoCambio==1">
                                <p class="text-center sub-cupon">Hemos mejorado tu tipo de cambio a <font size="3" face="arial black" >{{NuevoTipo}}</font>.</p>
                                <p class="text-center sub-cupon">Antes recibías <font size="3" face="arial black" > S/{{ValorRecibir1}}</font>
                                ahora recibirás <font size="3" face="arial black" > S/{{ValorRecibir3}}</font>
                                </p>  
                            </div>
                            <div v-if="tipoCambio==2">
                                <p class="text-center sub-cupon">Hemos mejorado tu tipo de cambio a <font size="3" face="arial black" >{{NuevoTipo}}</font>.</p>
                                <p class="text-center sub-cupon">Antes recibías <font size="3" face="arial black" > ${{ValorRecibir2}}</font>
                                ahora recibirás <font size="3" face="arial black" > ${{ValorRecibir4}}</font>
                                </p>
                            </div>
                        </div>
                        <!--
                            Antes recibías S/3881.00, con este cupón recibirás S/3884.00. 
                        --> 
                            <div>
                                <button class="w-100 btn btn-lg btn btn-registro " @click="iniciarOperacion">Iniciar operación</button>
                            </div>
                    </div> <!--calculadora-->

                    <div class="col-md-3 text-center p-5">
                        <img src="@/assets/img/rej.png" alt=""> <br>
                        <h6 class="text-center mt-2">Horario de atención</h6>
                        <p class="text-center" style="margin-top: -1%;">{{horaInicio}} {{horaFin}}</p> <br>

                        <img src="@/assets/img/tel.png" alt=""> <br>
                        <h6 class="text-center mt-2" >Contáctanos</h6>
                        <p class="text-center" style="margin-top: -1%;"><a :href="`tel:${numeroContacto}`"> {{numeroContacto}}</a></p>
                        <p style="margin-top: -4%;">Anexo 195</p>
                        <div class="">
                          <button type="button"  class="w-100 btn btn-sm btn-iniciar-sesion" @click="listarCuentaKallpa">CONSULTA NUESTRAS CUENTAS BANCARIAS <i class="fas fa-download"></i></button>
                        </div> 
                   </div>

                </div>
            </div>
        </main>

        <!-- Modal -->
        <div class="modal" tabindex="-1" id="modalMensaje">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">{{tituloMensaje}}</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <p>{{contenidoMensaje}}</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal" tabindex="-1" id="modalMensaje5000">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximo"></p>
                  <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximo2"></p>
                </div>
                <div class="modal-footer">
                  <a type="button" class="btn btn-iniciar-sesion " :href="linkWhatsApp" target="_blank">Enviar Mensaje</a>
                  <button type="button" class="btn btn-registro" data-bs-dismiss="modal" @click="continuarCambioMensaje">Seguir adelante</button>
                </div>
              </div>
            </div>
          </div>
    
          <div class="modal" tabindex="-1" id="modalMensaje10000">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <p style="font-size: 18px; text-align: justify; " v-text="mensajeMontoMaximoSegundo"></p>
                </div>
                <div class="modal-footer">
                  <a type="button" class="btn btn-iniciar-sesion " :href="linkWhatsApp" target="_blank">Enviar Mensaje</a>
                  <button type="button" class="btn btn-registro" data-bs-dismiss="modal" @click="continuarCambioMensaje">Seguir adelante</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Agregar Cuenta Banco-->
        <div class="modal fade" id="ag-cuenta-banco" tabindex="-1" aria-labelledby="ag-cuenta-bancoLabel" aria-hidden="true">
            <div class="modal-dialog">
            <div class="modal-content">
              <div class="m">
                <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
                <div class="modal-body">
                    <h2 class="titulo-registro text-center">Agregar tu cuenta bancaria</h2>
                        <!-- <p class="sub-titulo text-center">Para continuar debe agregar 
                        <br> una cuenta bancaria</p> -->
                         <div class="col-md-12 m-t-2">
                        <label for="" class="form-label">Titular de la cuenta</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.TitularCuenta" >
                            <option selected>{{nombreCompleto}}</option>
                        </select>
                        </div>

                       <div class="col-md-12 m-t-2">
                        <label for="firstName" class="form-label">Ponle un alias a tu cuenta</label>
                        <input type="text" class="form-control" id="firstName" placeholder=""  v-model="registerForm.NombreCuenta" required>
                      </div>
                      <div class="col-md-12 m-t-2">
                        <label for="" class="form-label">Banco</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoBanco">
                            <option v-for="(linea,index) in selectBank" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                        </select>
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="" class="form-label">Tipo de cuenta</label>
                            <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoCuenta">
                                <option v-for="(linea,index) in selectTipoC" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                            </select>  
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="" class="form-label">Moneda</label>
                            <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoModena">
                                <option v-for="(linea,index) in selectTipoMo" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                            </select>  
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="firstName" class="form-label">Número de tu cuenta</label>
                            <input type="text" class="form-control" id="firstName" placeholder=""  v-model="registerForm.NumeroCuenta" @keypress="soloNumeros" required>
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="firstName" class="form-label">Número de tu cuenta interbancaria</label>
                            <input type="text" class="form-control" id="firstName" placeholder=""  v-model="registerForm.CCI" @keypress="soloNumeros" required>
                        </div><br>

                        <p class="text-center">Podrás agregar otras cuentas más adelante en el módulo "Cuentas"</p>

                        <button class="w-100 btn btn-lg btn btn-registro" @click="registrarCuenta">Registrar cuenta</button>
                </div>
               
            </div>
            </div>
        </div><!-- Modal -->
   

           <!-- Modal cuentas kallpa-->
           <div class="modal fade" id="cuenta-banco-kallpa" tabindex="-1" aria-labelledby="cuenta-banco-kallpaLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="m">
                <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
                <div class="modal-body">
                    <h2 class="titulo-registro text-center">Cuentas bancarias <br> de Kallpa Securities S.A.B. </h2>
                    <div class="d-flex justify-content-center">
                    <a class="btn btn-sm btn-iniciar-sesion" :href="urlCuentasBancarias" target="_blank">Archivo de cuentas bancarias <i class="fas fa-download"></i></a>
                </div>
                    <br>
                    <div class="d-flex justify-content-between n-cuenta" v-for="(linea,index) in selectBankKallpa" :key='index'>
                        <div class="col-md-9 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1"><img :src="linea.Url_ImagenBanco" alt="" height="20">  </li>
                                <li class="">{{descMoCuenta}}</li>
                                <li>Nro Cuenta: {{linea.NumeroCuenta}}</li>
                                <li>CCI: {{linea.CCI}}</li>
                            </ul>
                        </div>
                        <div class="col-md-3 d-flex justify-content-end">
                            <ul class="list-ope">
                            <li><br></li>
                            <li><br></li>
                            <li><a href="" class="d-flex align-items-center" @click.prevent="copiar(linea.NumeroCuenta)">Copiar</a></li>
                            <li><a href="" class="d-flex align-items-center" @click.prevent="copiar(linea.CCI)">Copiar</a></li>
                            </ul>
                        </div>
                    </div>
                    <p class="text-center">RUC: 20492942121</p>
                      
                </div>
               
            </div>
            </div>
        </div><!-- Modal cuentas kallpa -->

        <div class="modal fade" id="mensajeAgregarCuenta" tabindex="-1" aria-labelledby="conf-operacionLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="m">  <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
                <div class="modal-body"> 
                  <br>
                  <h3 class="titulo-registro text-center">¡Bienvenido a Kallpa Cambios!</h3> <br>
                  <h4 class="t-c text-center" >Registra tus cuentas</h4>
                   <p class="text-center">Recuerda que debes registrar al menos una cuenta en dólares ó en soles para poder realizar tus operaciones de cambio</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-registro" @click="agregarBankCliente">Registrar Cuentas Bancarias </button>
                </div>
              </div>
            </div>
          </div>

        <div class="modal" tabindex="-1" id="modalMensajeFueraHorario">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-text="mensajeFueraHorario"></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" id="modalMensajeFeriado">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-text="mensajeFeriado"></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" id="modalMensajeFinSemana">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-text="mensajeFinSemana"></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" id="modalMensajeTipoCambioModificado">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-text="mensajeTipoCambioModificado"></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Si</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" id="modalMensajeEliminarBanco">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>¿ Esta Seguro de Eliminar el Banco?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-eliminar" data-bs-dismiss="modal" @click="continuarOperacion">SI</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

</div>
</template>

<script>

import auth from '@/services/auth'
import helpers from '@/services/helpers'

import Vue from 'vue';
import vueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
    export default {
      name: "InicioUsuario",
  
        data() {
      return {
        nombreCompleto:localStorage.getItem("nombreUsuario"),
        tipoCambio:1,
        Cupon:0,
        form:2,
        ValorCupon:"",
        NuevoTipo:"",
        ValorRecibir3:"",
        ValorRecibir4:"",
        IdCupon:"",
        MensajeCupon:"",
        DescuentoCupon:"",
        tipoMo:"",
        descMo:"",
        cuentasCliente:"",
        CambioCompra:"",
        CambioVenta:"",
        ValorEnviar:"",
        ValorRecibir:"",
        ValorEnviar1:"",
        TempValorEnviar1:"",
        TempValorRecibir1:"",
        ValorRecibir1:"",
        ValorEnviar2:"",
        ValorRecibir2:"",
        TempValorRecibir2:"",
        TempValorEnviar2:"",
        numeroContacto:"",
        horaInicio:"",
        horaFin:"",
        horaInicioAtencion:"",
        horaFinAtencion:"",
        mensajeFueraHorario:"",
        mensajeFeriado:"",
        mensajeFinSemana:"",
        tiempoEstimado:"",
        pasoOperacion1:"",
        pasoOperacion2:"",
        pasoOperacion3:"",
        disabled: true,
        tituloMensaje:"",
        contenidoMensaje:"",
        selectBankKallpa:[],
        selectBank:[],
        selectTipoC:[],
        selectTipoMo:[],
        cuentasClient:[],
        continuarCambio:0,
        montoMaximo:"",
        montoMaximoSegundo:"",
        mensajeMontoMaximo:"",
        mensajeMontoMaximo2:"",
        mensajeMontoMaximoSegundo:"",
        linkWhatsApp: '',
        registerForm:{
            TitularCuenta:"",
            NombreCuenta:"",
            IdTipoBanco: "",
            IdTipoCuenta: "",
            IdTipoModena: "",
            NumeroCuenta: "",
            CCI: "",
        },
        urlCuentasBancarias: "#",
        mensajeTipoCambioModificado: "",
        descMoCuenta:"",
    };
   },
mounted() {

      if(this.tipoCambio==1){
            this.tipoMo="TIMO0001";
            this.descMo="DÓLARES";
        }
        else{
            this.tipoMo="TIMO0002";
            this.descMo="SOLES";
        }
        this.listarBankClientMounted();
  },

    beforeCreate() {  

        helpers.actualizarTipoCambio(this);

        auth.listParameters().then(response => {
        
          this.selectBank=response.ParametrosGenerales.filter(e=>e.IdParametro=="BANC");
          this.selectTipoC=response.ParametrosGenerales.filter(e=>e.IdParametro=="TICU");
          this.selectTipoMo=response.ParametrosGenerales.filter(e=>e.IdParametro=="TIMO");
          this.numeroContacto=response.ParametrosGenerales.find(e=>e.Id=="NUKA0001").ValorParametroValor;
          this.horaInicio=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").ValorParametroValor;
          this.horaFin=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").ValorParametroValor;
          this.horaInicioAtencion=response.ParametrosGenerales.find(e=>e.Id=="HOAT0001").DetalleParametroValor;
          this.horaFinAtencion=response.ParametrosGenerales.find(e=>e.Id=="HOAT0002").DetalleParametroValor;
          this.tiempoEstimado=response.ParametrosGenerales.find(e=>e.Id=="TITU0001").NombreParametroValor;
          this.pasoOperacion1=response.ParametrosGenerales.find(e=>e.Id=="TITU0014").NombreParametroValor;
          this.pasoOperacion2=response.ParametrosGenerales.find(e=>e.Id=="TITU0015").NombreParametroValor;
          this.pasoOperacion3=response.ParametrosGenerales.find(e=>e.Id=="TITU0016").NombreParametroValor;
          this.mensajeAtencion=response.ParametrosGenerales.find(e=>e.Id=="MENS0001");
          this.mensajeAtencion2=response.ParametrosGenerales.find(e=>e.Id=="MENS0009");
          this.montoMaximo=response.ParametrosGenerales.find(e=>e.Id=="MMDO0001").ValorParametroValor;
          this.montoMaximoSegundo=response.ParametrosGenerales.find(e=>e.Id=="MMDO0002").ValorParametroValor;
          this.mensajeMontoMaximo=response.ParametrosGenerales.find(e=>e.Id=="MENS0001").DetalleParametroValor;
          this.mensajeFueraHorario=response.ParametrosGenerales.find(e=>e.Id=="MENS0002").DetalleParametroValor;
          this.mensajeFeriado=response.ParametrosGenerales.find(e=>e.Id=="MENS0010").DetalleParametroValor;
          this.mensajeFinSemana=response.ParametrosGenerales.find(e=>e.Id=="MENS0011").DetalleParametroValor;
          this.mensajeMontoMaximo2=response.ParametrosGenerales.find(e=>e.Id=="MENS0009").DetalleParametroValor;
          this.linkWhatsApp=response.ParametrosGenerales.find(e=>e.Id=="MENS0003").DetalleParametroValor;
          this.mensajeMontoMaximoSegundo=response.ParametrosGenerales.find(e=>e.Id=="MENS0004").DetalleParametroValor;
          this.tituloMensaje=this.mensajeAtencion.NombreParametroValor;
          this.contenidoMensaje=this.mensajeAtencion.DetalleParametroValor;
          this.urlCuentasBancarias = response.ParametrosGenerales.find(e=>e.Id=="MENS0005").DetalleParametroValor;

          this.CambioCompra=this.$store.getters.getTipoCambio('compra');
          this.CambioVenta=this.$store.getters.getTipoCambio('venta');
          if(!localStorage.getItem("valorEnviar")){ 
            this.ValorEnviar1=numeral(response.ParametrosGenerales.find(e=>e.Id=="MPDC0001").ValorParametroValor).format('0,0.00');
            this.ValorRecibir1=numeral(numeral(this.ValorEnviar1).value()*this.CambioCompra).format('0,0.00');
          }else{
              
              this.tipoCambio= localStorage.getItem("tipoCambio");
            
                if(this.tipoCambio==1){
                    this.ValorEnviar1=numeral(localStorage.getItem("valorEnviar")).format('0.00');
                    this.ValorRecibir1=numeral(numeral(this.ValorEnviar1).value()*this.CambioCompra).format('0.00');
                }
                else{
                    this.ValorEnviar2=numeral(localStorage.getItem("valorEnviar")).format('0.00');
                    this.ValorRecibir2=numeral(numeral(this.ValorEnviar2).value()/this.CambioVenta).format('0.00');
                }    
          }
          if(this.CambioCompra!=null){
            this.disabled=false;
          }
          else{
          this.disabled=true;
          }
    });
    
  },
      methods:{
    agregarBankCl(){
        $('#ag-cuenta-banco').modal('show');
    },
    agregarBankCliente(){
        $('#mensajeAgregarCuenta').modal('hide');
        $('#ag-cuenta-banco').modal('show');
    },

    listarBankClient(){
        auth.listBankClient(this,this.tipoMo).then(response => {
        this.cuentasCliente=response.filter(e=>e.Moneda==this.tipoMo).length;
         if(this.cuentasCliente==0){
             this.form=1;
         }
         else{
             this.form=2;
         }
     }); 
    },
    listarBankClientMounted(){
        auth.listBankClient(this,this.tipoMo).then(response => {
            this.cuentasCliente=response.filter(e=>e.Moneda==this.tipoMo).length;
            if(this.cuentasCliente==0){
                this.form=1;
                if(!localStorage.getItem("ocultarMensajeInicio"))
                    $('#mensajeAgregarCuenta').modal('show');
                localStorage.setItem("ocultarMensajeInicio", true);
            }
            else{
                this.form=2;
            }
        }); 
    },

    validarCupon(){

        auth.validarCouponUser(this.ValorCupon).then((response) => {
                
                  //console.log(response);
                  if(response.data.m_Item1[0].Mensaje=="OK"){
                    //toastr["success"](this.MensajeCupon);
                      this.Cupon=1;
                      this.IdCupon=response.data.m_Item1[0].Id
                      this.MensajeCupon=response.data.m_Item1[0].Mensaje
                      this.DescuentoCupon=response.data.m_Item1[0].Descuento
                                                          
                      this.CambiarMonedaEnviar();

                  }else{
                      this.Cupon=0;
                      this.IdCupon=response.data.m_Item1[0].Id
                      this.MensajeCupon=response.data.m_Item1[0].Mensaje
                      this.DescuentoCupon=response.data.m_Item1[0].Descuento
                      toastr["error"](this.MensajeCupon);
                      this.limpiarCupon();
                  }
                })
                .catch((error) => {
                  console.log(error);

                });
      },
      
    limpiarCupon(){
        this.ValorCupon="";
        this.DescuentoCupon=0;
        localStorage.setItem("MontoCupon", 0);
        this.Cupon=0;
        this.ValorRecibir3=0;
        this.ValorRecibir4=0;
        this.NuevoTipo=0;
        this.CambiarMonedaEnviar();
    },
    iniciarOperacion(){
        /*
        auth.validateTime().then(response => {
           if(response=="True"){
               axios.get('api/parametro/ListaTipoCambioActual' )
                .then(response => {   
                    
                    let compraNuevo = response.data.Data.find(e=>e.Id=="5").TipoCambio;
                    let ventaNuevo = response.data.Data.find(e=>e.Id=="4").TipoCambio;

                    if(this.$store.getters.getTipoCambio('compra') != compraNuevo || this.$store.getters.getTipoCambio('venta') != ventaNuevo ){
                        this.mensajeTipoCambioModificado = "El tipo de cambio ha variado. Los precios son: Ahora compramos a "+ compraNuevo +" y vendemos a "+ ventaNuevo +". ¿Desea continuar con la operación?";
                        $('#modalMensajeTipoCambioModificado').modal('show');
                        this.$store.dispatch('setTipoCambio',{
                            compra: compraNuevo,
                            venta: ventaNuevo,
                        });
                    }
                    else{
                        this.continuarOperacion();
                    }
                }).catch(error => {
                    toastr['error'](error.response.data.message);
                }); 
               }
           else{
              $('#modalMensajeFueraHorario').modal('show');
           }
        */
        auth.validateTimeGeneral().then(response => {
           if(response==0){
              $('#modalMensajeFueraHorario').modal('show');
           }
           else if(response==1)
           {
               axios.get('api/parametro/ListaTipoCambioActual')
                .then(response => {   
                    
                    let compraNuevo = response.data.Data.find(e=>e.Id=="5").TipoCambio;
                    let ventaNuevo = response.data.Data.find(e=>e.Id=="4").TipoCambio;

                    if(this.$store.getters.getTipoCambio('compra') != compraNuevo || this.$store.getters.getTipoCambio('venta') != ventaNuevo ){
                        this.mensajeTipoCambioModificado = "El tipo de cambio ha variado. Los precios son: Ahora compramos a "+ compraNuevo +" y vendemos a "+ ventaNuevo +". ¿Desea continuar con la operación?";
                        $('#modalMensajeTipoCambioModificado').modal('show');
                        this.$store.dispatch('setTipoCambio',{
                            compra: compraNuevo,
                            venta: ventaNuevo,
                        });
                        // Agregado para el cupon
                        this.CambioCompra = compraNuevo;
                        this.CambioVenta = ventaNuevo;
                        this.validarCupon();
                    }
                    else{

                        this.continuarOperacion();

                    }
                }).catch(error => {
                    toastr['error'](error);
                }); 
           }
           else if(response==2)
           {
              $('#modalMensajeFeriado').modal('show');
           }
           else if(response==3)
           {
              $('#modalMensajeFinSemana').modal('show');
           }

         }); 
    },
    soloNumeros($event){
          helpers.soloNumeros($event);
        },
    continuarCambioMensaje(){
        this.iniciarOperacion();
    },
    continuarOperacion(){
        auth.listBankClient(this,this.tipoMo).then(response => {
            this.cuentasCliente=response.filter(e=>e.Moneda==this.tipoMo).length;
            if(this.cuentasCliente==0){
                this.form=1;
                $('#ag-cuenta-banco').modal('show');
            }
            else{
                this.form=2;
                if(this.tipoCambio==1){

                    localStorage.setItem("valorEnviar", this.ValorEnviar1);
                    localStorage.setItem("valorRecibir", this.ValorRecibir1);
                    // cupon
                    localStorage.setItem("MontoCupon", this.ValorRecibir3);
                }
                else{

                    localStorage.setItem("valorEnviar", this.ValorEnviar2);
                    localStorage.setItem("valorRecibir", this.ValorRecibir2);
                    // cupon
                    localStorage.setItem("MontoCupon", this.ValorRecibir4);
                }
                
                localStorage.setItem("tipoCambio", this.tipoCambio);
                localStorage.setItem("cambioCompra", this.$store.getters.getTipoCambio('compra'));
                localStorage.setItem("cambioVenta", this.$store.getters.getTipoCambio('venta'));

                // Asignar Datos Cupon

                localStorage.setItem("IdCupon",this.IdCupon);
                localStorage.setItem("MensajeCupon", this.MensajeCupon);
                localStorage.setItem("DescuentoCupon", this.DescuentoCupon);

                this.$router.push("/user-operacion").catch(err => {});
            }
        });
    },
      
    tipocambiar(){
        
        if(this.tipoCambio=="1"){
            this.tipoCambio="2";
            this.tipoMo="TIMO0002";
            this.descMo="SOLES";
            this.ValorEnviar2=this.ValorEnviar1;
            this.CambiarMonedaEnviar();
        }
        else{
            this.tipoCambio="1";
            this.tipoMo="TIMO0001";
            this.descMo="DÓLARES";
            this.ValorEnviar1=this.ValorEnviar2;
            this.CambiarMonedaEnviar();
        }

        this.listarBankClient();

    },
    soloFloatEnviar($event){
        helpers.soloFloat($event);
        this.ValorEnviar=$event.target.value;
    },
    soloFloatRecibir($event){
        helpers.soloFloat($event);
        this.ValorRecibir=$event.target.value;
    },

    CambiarMonedaRecibir(){
        const regExp = new RegExp( /^\d{0,6}(\.\d{0,2})*(,\d+)?$/ ); // --- sin comillas
      
        if(this.tipoCambio=="1"){
            let resultado = regExp.test( this.ValorRecibir1 );
            if (resultado) {
                this.TempValorRecibir1 = this.ValorRecibir1;
            } else {
                this.ValorRecibir1=this.TempValorRecibir1;
            }
            if((numeral(this.ValorRecibir1).value()/this.CambioCompra)>this.montoMaximoSegundo ){
                this.ValorRecibir1=this.ValorRecibir;
                $('#modalMensaje10000').modal('show');
            }
            else if((numeral(this.ValorRecibir1).value()/this.CambioCompra)>this.montoMaximo && this.continuarCambio==0){
                $('#modalMensaje5000').modal('show');
            }
            this.ValorEnviar1=numeral(helpers.convertirEnviar(numeral(this.ValorRecibir1).value(),this.CambioCompra,true)).format('0,0.00');
        }
        else{
             let resultado = regExp.test( this.ValorRecibir2 );
            if (resultado) {
                this.TempValorRecibir2 = this.ValorRecibir2;
            } else {
                this.ValorRecibir2=this.TempValorRecibir2;
            }
            if(numeral(this.ValorRecibir2).value()>this.montoMaximoSegundo ){
                this.ValorRecibir2=this.ValorRecibir;
                $('#modalMensaje10000').modal('show');
            }
            else if(numeral(this.ValorRecibir2).value()>this.montoMaximo && this.continuarCambio==0){
                $('#modalMensaje5000').modal('show');
            }
            this.ValorEnviar2=numeral(helpers.convertirEnviar(numeral(this.ValorRecibir2).value(),this.CambioVenta,false)).format('0,0.00');
        }
    },
    CambiarMonedaEnviar(){
        const regExp = new RegExp( /^\d{0,6}(\.\d{0,2})*(,\d+)?$/ ); // --- sin comillas
        if(this.tipoCambio=="1"){
            let resultado = regExp.test( this.ValorEnviar1 );
            if (resultado) {
                this.TempValorEnviar1 = this.ValorEnviar1;
            } else {
                this.ValorEnviar1=this.TempValorEnviar1;
            }
            if(numeral(this.ValorEnviar1).value()>this.montoMaximoSegundo ){
                this.ValorEnviar1=this.ValorEnviar;
                $('#modalMensaje10000').modal('show');
            }
            else if(numeral(this.ValorEnviar1).value()>this.montoMaximo && this.continuarCambio==0){
                $('#modalMensaje5000').modal('show');
            }
            this.ValorRecibir1=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar1).value(),this.CambioCompra,true)).format('0,0.00');
            //Calcular cupon
            this.NuevoTipo=(Number(this.CambioCompra)+Number(this.DescuentoCupon)).toFixed(4);
            this.ValorRecibir3=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar1).value(),(this.CambioCompra+this.DescuentoCupon),true)).format('0,0.00');
            
        }
        else{
            let resultado = regExp.test( this.ValorEnviar2 );
            if (resultado) {         
                this.TempValorEnviar2 = this.ValorEnviar2;
            } else {
                this.ValorEnviar2=this.TempValorEnviar2;
            }
            if((numeral(this.ValorEnviar2).value()/this.CambioVenta)>this.montoMaximoSegundo ){
                //this.ValorEnviar2=this.ValorEnviar;
                $('#modalMensaje10000').modal('show');
            }
            else if((numeral(this.ValorEnviar2).value()/this.CambioVenta)>this.montoMaximo && this.continuarCambio==0){
                $('#modalMensaje5000').modal('show');
            }
            this.ValorRecibir2=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar2).value(),this.CambioVenta,false)).format('0,0.00');
            // Calcular cupon
            this.NuevoTipo=(Number(this.CambioVenta)-Number(this.DescuentoCupon)).toFixed(4);
            this.ValorRecibir4=numeral(helpers.convertirRecibir(numeral(this.ValorEnviar2).value(),this.CambioVenta-this.DescuentoCupon,false)).format('0,0.00');
            
        }
    },

    listarCuentaKallpa(){
        var tipoMoK="";
        if(this.tipoCambio=="1"){
            tipoMoK="TIMO0002";
            this.descMoCuenta="DÓLARES";
        }
        else{
            tipoMoK="TIMO0001";
            this.descMoCuenta="SOLES";
        }
        debugger
        auth.listBankKallpa(this,tipoMoK).then(response => {
        this.selectBankKallpa=response.filter(e=>e.TipoMoneda==tipoMoK);
         $('#cuenta-banco-kallpa').modal('show');
    });
    },
/*
    listarCuentaK(){
        var tipoMoK="";
        if(this.tipoMo=="TIMO0001"){
            tipoMoK="TIMO0002";
        }
        else{
            tipoMoK="TIMO0001";
        }

        auth.listBankKallpa(this,tipoMoK).then(response => {
        this.selectBankKallpa=response.filter(e=>e.TipoMoneda==tipoMoK);
    });    
    },
*/
    registrarCuenta(){
        if(this.registerForm.NombreCuenta!="" && this.registerForm.NumeroCuenta!=""){
           
            if (auth.registerBankClient(this)){
                this.form=2;
                this.limpiarRegitrarCuenta();
                $('#ag-cuenta-banco').modal('hide');
                
            // toastr["success"]("Se registró cuenta correctamente");
           }
        }
        else{
            toastr["error"]("Ingrese nombre y número de Cuenta");
        }
    },

    limpiarRegitrarCuenta(){
        this.registerForm.NombreCuenta="";
        this.registerForm.IdTipoBanco="";        
        this.registerForm.IdTipoCuenta="";
        this.registerForm.IdTipoModena="";
        this.registerForm.NumeroCuenta=""; 
        this.registerForm.CCI="";     
    },
    
    copiar(valor){
        valor=valor.replace("-", "");
            valor=valor.replace("-", "");
                valor=valor.replace("-", "");
        
        var textarea = document.createElement('textarea');
                textarea.textContent = valor; //con esto es cambia la url por el valor que deseas copiar
                document.body.appendChild(textarea);

                var selection = document.getSelection();
                var range = document.createRange();
                //  range.selectNodeContents(textarea);
                range.selectNode(textarea);
                selection.removeAllRanges();
                selection.addRange(range);

                document.execCommand('copy');
                
                selection.removeAllRanges();

                document.body.removeChild(textarea);
                toastr["success"]('Se copió al portapapeles');
    },
      },
    };
    </script>


// WEBPACK FOOTER //
// src/components/user/InicioUsuario.vue